import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ModelCategoryConfigurationTabs from './ModelCategoryConfigurationTabs';
import s from './ModelCategoryConfigurationContentTemplate.module.scss';
import { useSelector } from 'react-redux';
import { getUserOrgModelCategoryType } from '../../selectors/index';
import { useParams } from 'react-router-dom';

const ModelCategoryConfigurationContentTemplate = ({ children, selectedPage = '', userProfileWidgets }) => {

  const userModelCategories = useSelector(state => getUserOrgModelCategoryType(state));
  let { ModelCategoryId } = useParams();

  const getModelCategoryName = () => {
    if (userModelCategories && userModelCategories.length > 0) {
      const modelCategory = userModelCategories.find(category => category.ModelCategoryId === parseInt(ModelCategoryId, 10));
      return modelCategory ? modelCategory.ModelCategoryName : '';
    }
    return '';
  }



  return (
    <Fragment>
      <div className={s.fullWidth}>
        <div className={s.fullWidthWrapper}>
          <h1 className={s.tabHeader}>{<FormattedMessage id="modelcategory.modelCategoryConfiguration" defaultMessage="Model Category Configuration" />} - {getModelCategoryName()} </h1>
          {<ModelCategoryConfigurationTabs selectedPage={selectedPage} userProfileWidgets={userProfileWidgets} />}
        </div>
      </div>

      <div className={s.pageContent}>{children}</div>
    </Fragment>)
};

ModelCategoryConfigurationContentTemplate.propTypes = {
  backLink: PropTypes.string,
  children: PropTypes.node.isRequired,
  selectedPage: PropTypes.string,
  userProfileWidgets: PropTypes.object
};

export default ModelCategoryConfigurationContentTemplate;
